import React from 'react'
import { useSelector } from 'react-redux'

export default function PreviewFooter(props){
    const {auctionData}=props;
    const profile = useSelector((state) => state.profile);
    
    // Construct social links array based on profile or defaults
    const socialLinks = [
        { name: 'instagram', url: profile?.instagram_link, icon: '/images/instagram-blackwhite.png' },
        { name: 'facebook', url: profile?.facebook_link, icon: '/images/facebook-blackwhite.png' },
        { name: 'twitter', url: profile?.twitter_link, icon: '/images/twitter-blackwhite.png' },
        { name: 'linkedin', url: profile?.linkedin_link, icon: '/images/linkedin-blackwhite.png' }
    ];

    // Check if any link is defined, otherwise we show all 4 as placeholders
    const hasAnyLink = socialLinks.some(link => link.url && link.url !== '');
    
    return(
        <footer className="bg-[#E6E6E6]" style={{backgroundColor: auctionData.footer['background_color']}}>
            <div className="flex justify-between  px-7 items-center">
                <p className="text-[12px] py-8 text-[#282828] font-medium leading-normal" data-testid='footer-indy-logo'
                    style={{color: auctionData.footer['text_color']}}
                >
                    Powered by <a href="#" className="underline cursor-pointer hover:opacity-70 transition-opacity">
                        indy.auction
                    </a> 
                </p>
                <div className="flex items-center gap-3">
                    {socialLinks.map((social) => {
                        return (
                            <a key={social.name} 
                                href={social.url || '#'} 
                                target={social.url ? "_blank" : "_self"}
                                rel="noreferrer"
                                className="cursor-pointer hover:opacity-70 transition-opacity flex items-center">
                                <img src={social.icon} alt={social.name} />
                            </a>
                        )
                    })}
                </div>
            </div>
        </footer>
    )
}